import React from 'react';

const Privacy = () => {
  const lastUpdated = "March 16, 2026";
  const supportEmail = "support@hashhouseyoga.com";

  return (
    <div className="max-w-4xl mx-auto px-6 py-12 text-gray-800 leading-relaxed">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p className="text-sm text-gray-500 mb-8">Last Updated: {lastUpdated}</p>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">1. Introduction</h2>
        <p>
          Hash House Yoga ("we," "us," or "our") operates the application located at 
          <strong> hashhouseyoga.com</strong>. We respect your privacy and are committed 
          to protecting the personal information you share with us via Google OAuth.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">2. Information We Collect</h2>
        <p className="mb-2">When you authenticate using your Google Account, we access the following information:</p>
        <ul className="list-disc ml-6 space-y-1">
          <li><strong>Email Address:</strong> To identify your account and communicate essential service updates.</li>
          <li><strong>Name & Profile Picture:</strong> To personalize your experience within the HHY dashboard.</li>
        </ul>
      </section>

      <section className="mb-8 border-l-4 border-blue-500 pl-4 bg-blue-50 py-2">
        <h2 className="text-xl font-semibold mb-3">3. Google API Disclosure (Limited Use)</h2>
        <p>
          Hash House Yoga's use and transfer of information received from Google APIs to any other app 
          will adhere to the <a href="https://developers.google.com/terms/api-services-user-data-policy" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">Google API Services User Data Policy</a>, 
          including the <strong>Limited Use</strong> requirements. We do not sell your data to third parties 
          or use it for advertising purposes.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">4. Data Retention & Deletion</h2>
        <p>
          We retain your data only as long as your account is active. If you wish to revoke access 
          or delete your account and associated data, please contact us at 
          <a href={`mailto:${supportEmail}`} className="text-blue-600 ml-1 font-medium">{supportEmail}</a>.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">5. Security</h2>
        <p>
          We implement industry-standard security measures to protect your information. 
          However, no method of transmission over the internet is 100% secure, and we 
          cannot guarantee absolute security.
        </p>
      </section>

      <footer className="mt-12 pt-8 border-t border-gray-200">
        <p className="text-sm text-gray-600">
          Contact our privacy team at: <span className="font-semibold">{supportEmail}</span>
        </p>
      </footer>
    </div>
  );
};

export default Privacy;
